<template>
  <div>
    <router-link to="/" style="display: block; margin-bottom: 40px;">
      <i class="material-icons">keyboard_backspace</i>
    </router-link>
    <div style="display: block; margin-bottom: 56px; font-size: large; font-weight: bold;">
    <slot name="title"/>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PageSecondary",
  mounted() {
    this.$nextTick(()=>{

    })
  }
}
</script>

<style scoped>

</style>
